import React, {createContext, useEffect, useRef} from 'react';

import useAuth from './hooks/useAuth';
import axios from "axios";
import {useLocation} from "react-router-dom";
import {useToast} from "@chakra-ui/react";

const Context = createContext();

function AuthProvider({children}) {

    const {
        authenticated,
        loading,
        handleLogin,
        handleMailPinCodeLogin,
        handleLogout,
        authRefresh,
        authUser,
        authCompany,
        authRole,
        authCompanyConfig,
        authOwnPermissions,
        authIsSuperAdmin,
        authSimulating,
        startSimulation,
        stopSimulation,
        authHasAnyPermission
    } = useAuth();

    const toast = useToast();
    const redirectTo = '/home';

    const location = useLocation();
    const locationRef = useRef(location);
    const handleLogoutRef = useRef(handleLogout);

    useEffect(() => {
        locationRef.current = location;
    }, [location]);

    useEffect(() => {
        handleLogoutRef.current = handleLogout;
    }, [handleLogout]);

    useEffect(() => {
        const interceptor = axios.interceptors.response.use(response => {
            return response;
        }, error => {
            if (error?.response?.status === 401 && !locationRef.current.pathname.includes('/login')) {
                toast({
                    isClosable: true,
                    title: "Sessão expirada",
                    description: "Sua sessão expirou. Faça login novamente para continuar.",
                    position: "bottom-right",
                    status: "warning",
                    duration: 6000,
                });

                handleLogoutRef.current(redirectTo);
            }

            return Promise.reject(error.response || error);
        });

        return () => axios.interceptors.response.eject(interceptor);
    }, []);

    return (
        <Context.Provider value={{
            loading,
            authenticated,
            handleLogin,
            handleMailPinCodeLogin,
            handleLogout,
            authRefresh,
            authUser,
            authCompany,
            authRole,
            authCompanyConfig,
            authOwnPermissions,
            authIsSuperAdmin,
            authSimulating,
            startSimulation,
            stopSimulation,
            authHasAnyPermission
        }}>
            {children}
        </Context.Provider>
    );
}

export {Context, AuthProvider};
